<template>
  <v-dialog v-model="dialog" max-width="800px" persistent>
    <v-card>
      <v-card-title class="text-h6"> 상품 편집 - {{ product.id }} </v-card-title>

      <v-card-text>
        <v-container>
          <v-row>
            <v-col cols="12" md="3">
              <v-text-field label="가격(KRW)" v-model.number="localProduct.price" type="number" hide-spin-buttons dense outlined></v-text-field>
            </v-col>
            <v-col cols="12" md="3">
              <v-select label="타입" v-model="localProduct.type" :items="['single', 'group']" dense outlined @change="onTypeChange"></v-select>
            </v-col>
            <v-col cols="12" md="3">
              <v-select label="무료 보정 갯수" v-model.number="localProduct.freePicEditCount" :items="[0, 1, 2, 3, 4, 5, 6, 7, 8, 9]" dense outlined></v-select>
            </v-col>
            <v-col cols="12" md="3">
              <v-text-field
                label="최대 인원"
                v-model.number="localProduct.maxpersons"
                type="number"
                :disabled="localProduct.type === 'single'"
                :min="localProduct.type === 'single' ? 1 : 2"
                :max="6"
                :rules="maxpersonsRules"
                dense
                outlined
                @input="validateMaxpersons"
              ></v-text-field>
            </v-col>
          </v-row>

          <v-divider class="my-4"></v-divider>

          <v-row>
            <v-col cols="12">
              <div class="font-weight-bold mb-2">제목 (한글)</div>
              <v-text-field v-model="localProduct.title.kr" placeholder="제목을 입력하세요" :counter="20" maxlength="20" dense outlined></v-text-field>
            </v-col>
            <v-col cols="12">
              <div class="font-weight-bold mb-2">부제목 (한글)</div>
              <v-text-field v-model="localProduct.subtitle.kr" placeholder="부제목을 입력하세요" :counter="50" maxlength="50" dense outlined></v-text-field>
            </v-col>
          </v-row>

          <v-divider class="my-4"></v-divider>

          <v-row>
            <v-col cols="12">
              <div class="font-weight-bold mb-2">제목 (영어)</div>
              <v-text-field v-model="localProduct.title.en" placeholder="Enter title" :counter="20" maxlength="20" dense outlined></v-text-field>
            </v-col>
            <v-col cols="12">
              <div class="font-weight-bold mb-2">부제목 (영어)</div>
              <v-text-field v-model="localProduct.subtitle.en" placeholder="Enter subtitle" :counter="50" maxlength="50" dense outlined></v-text-field>
            </v-col>
          </v-row>

          <v-divider class="my-4"></v-divider>

          <v-row>
            <v-col cols="12">
              <div class="font-weight-bold mb-2">제목 (일본어)</div>
              <v-text-field v-model="localProduct.title.jp" placeholder="タイトルを入力してください" :counter="20" maxlength="20" dense outlined></v-text-field>
            </v-col>
            <v-col cols="12">
              <div class="font-weight-bold mb-2">부제목 (일본어)</div>
              <v-text-field v-model="localProduct.subtitle.jp" placeholder="サブタイトルを入力してください" :counter="50" maxlength="50" dense outlined></v-text-field>
            </v-col>
          </v-row>

          <v-divider class="my-4"></v-divider>

          <v-row>
            <v-col cols="12">
              <v-text-field label="순서" v-model.number="localProduct.order" type="number" dense outlined></v-text-field>
            </v-col>
          </v-row>
        </v-container>
      </v-card-text>

      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="grey" text @click="cancel"> 취소 </v-btn>
        <v-btn color="primary" @click="save"> 저장 </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: "ProductEditDialog",
  props: {
    value: {
      type: Boolean,
      default: false,
    },
    product: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      localProduct: {
        id: "",
        price: 0,
        maxpersons: 1,
        type: "single",
        freePicEditCount: 1,
        title: { kr: "", en: "", jp: "" },
        subtitle: { kr: "", en: "", jp: "" },
        order: 1,
      },
      maxpersonsRules: [
        (v) => !!v || "최대 인원을 입력해주세요",
        (v) => !isNaN(v) || "숫자만 입력 가능합니다",
        (v) => v >= 2 || "최소 2명 이상 입력해주세요",
        (v) => v <= 6 || "최대 6명까지만 입력 가능합니다",
      ],
    }
  },
  computed: {
    dialog: {
      get() {
        return this.value
      },
      set(val) {
        this.$emit("input", val)
      },
    },
  },
  watch: {
    product: {
      immediate: true,
      deep: true,
      handler(newVal) {
        if (newVal) {
          this.localProduct = JSON.parse(JSON.stringify(newVal))
        }
      },
    },
  },
  methods: {
    onTypeChange() {
      if (this.localProduct.type === "single") {
        this.localProduct.maxpersons = 1
      } else if (this.localProduct.type === "group" && this.localProduct.maxpersons === 1) {
        this.localProduct.maxpersons = 2
      }
    },
    validateMaxpersons(value) {
      // 숫자가 아닌 경우 제거
      if (isNaN(value)) {
        this.localProduct.maxpersons = 2
        return
      }

      // 2~6 범위 체크
      if (this.localProduct.type === "group") {
        if (value < 2) {
          this.localProduct.maxpersons = 2
        } else if (value > 6) {
          this.localProduct.maxpersons = 6
        }
      }
    },
    cancel() {
      this.dialog = false
    },
    save() {
      // 저장 전 최종 검증
      if (this.localProduct.type === "group") {
        if (!this.localProduct.maxpersons || isNaN(this.localProduct.maxpersons)) {
          this.$toast.error("최대 인원을 올바르게 입력해주세요")
          return
        }
        if (this.localProduct.maxpersons < 2 || this.localProduct.maxpersons > 6) {
          this.$toast.error("그룹 타입의 최대 인원은 2~6명 사이여야 합니다")
          return
        }
      }

      this.$emit("save", this.localProduct)
      this.dialog = false
    },
  },
}
</script>
